export default "__VITE_ASSET__bd07af15__"